// ==============================|| OVERRIDES - CARD CONTENT ||============================== //

import { Theme } from '@mui/material/styles';

export default function CardContent(theme: Theme) {
  return {
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '14px',
          [theme.breakpoints.up('md')]: {
            padding: '23px'
          },
          '&:last-child': {
            padding: '14px',
            [theme.breakpoints.up('md')]: {
              padding: '23px'
            }
          }
        }
      }
    }
  };
}
